export default __webpack_public_path__ + "static/media/trackinfo_overview.d652dbac.png";